import * as stylex from "@stylexjs/stylex";
import * as F from "fp-ts";
import * as React from "react";
import { useComputedStyle } from "@/hooks/useComputedStyle";
import { Columns } from "./internal";
/**
 * The underlying DOM element which is rendered by this component.
 */ const Root = "div";
export function Masonry(props) {
    const { children, ...rest } = props;
    /*
   * We watch the computed value of the 'grid-template-columns' property to
   * determine how many columns the element is displaying.
   */ const [ref, computedStyle] = useComputedStyle([
        "gridTemplateColumns"
    ]);
    const numColumns = computedStyle?.gridTemplateColumns.split(" ").length ?? 1;
    /*
   * An array of refs which are passed to each column. This array always has
   * length same as 'numColumns'.
   *
   * The refs are used to calculate the height of each column, to find which one
   * is the shortest and where the next item should be placed in.
   */ const refs = React.useMemo(()=>F.nonEmptyArray.makeBy(()=>({
                current: null
            }))(numColumns), [
        numColumns
    ]);
    /*
   * The actual child elements that we should be showing. The array identity
   * only changes when the children change.
   */ const childElements = React.useMemo(()=>React.Children.toArray(children).filter(isValidChild), [
        children
    ]);
    return <Root ref={ref} className="xrvj5dj x4tlyms x1izhsip x7a106z x75wj2q" {...rest}>
      {computedStyle && <Columns key={numColumns} refs={refs} childElements={childElements}/>}
    </Root>;
}
function isValidChild(u) {
    return React.isValidElement(u) && u.key !== null;
}
